import { Pill } from './Pill';
import { domainChip, jobStatusChip, scheduleChip } from '../lib/jobChips';

export function DomainChip({ domain }: { domain: string }) {
  const c = domainChip(domain);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}

export function JobStatusChip({ status }: { status: string }) {
  const c = jobStatusChip(status);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}

export function ScheduleChip({ schedule }: { schedule: string }) {
  const c = scheduleChip(schedule);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}
